import { get } from './global.service';
import { showNotification } from './notifications.service';

export const createGuid = () => {
    return [
        Math.random().toString(16).slice(2, 10),
        Math.random().toString(16).slice(2, 6),
        (Math.random() * 0.0625 /* 0x.1 */ + 0.25) /* 0x.4 */
            .toString(16)
            .slice(2, 6),
        (Math.random() * 0.25 /* 0x.4 */ + 0.5) /* 0x.8 */
            .toString(16)
            .slice(2, 6),
        Math.random().toString(16).slice(2, 14)
    ].join('-');
};

export const deepCompareJson = (arg1: any, arg2: any, excludeKeys?: string[]): boolean => {
    if (Object.prototype.toString.call(arg1) === Object.prototype.toString.call(arg2)) {
        if (Object.prototype.toString.call(arg1) === '[object Object]' || Object.prototype.toString.call(arg1) === '[object Array]') {
            if (Object.keys(arg1).length !== Object.keys(arg2).length) {
                return false;
            }
            return Object.keys(arg1).every(key => {
                if (excludeKeys?.includes(key)) return true;
                return deepCompareJson(arg1[key], arg2[key], excludeKeys);
            });
        }
        return arg1 === arg2;
    }
    return false;
};

export const showError = (message: string) => {
    showNotification(
        {
            message: message,
            status: 'danger',
            pos: 'top-center',
            timeout: 3000
        },
        'ico-Danger-Fill'
    );
};

export const showSuccess = (message: string) => {
    showNotification(
        {
            message: message,
            status: 'success',
            pos: 'top-center',
            timeout: 3000
        },
        'ico-Check-Circle-Fill'
    );
};

export const showWarning = (message: string) => {
    showNotification(
        {
            message: message,
            status: 'warning',
            pos: 'top-center',
            timeout: 3000
        },
        'ico-Warning-Fill'
    );
};

export const removeDuplicatesByProperty = (array, property) => {
    return array.filter((obj, index, self) => index === self.findIndex(t => t[property] === obj[property]));
};

export const getImageLink = (item: any): string => {
    // Guard against null or non-object
    if (!item || typeof item !== 'object') {
        return null;
    }

    // Image file extensions to check for
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.bmp'];

    // Common image hosting domains
    const imageHosts = [
        'blob.core.windows.net',
        'images',
        'photos',
        'img',
        'cdn',
        'storage',
        'assets'
    ];

    // Image-related URL patterns and keywords
    const imageUrlPatterns = [
        '/image',
        '/img',
        '/photo',
        '/picture',
        '/thumbnail',
        'image?',
        'img?',
        'photo?',
        'picture?',
        'thumbnail?'
    ];

    // First check known possible image properties
    const commonImageProps = ['image_link', 'imageLink', 'image', 'img', 'thumbnail', 'pictureUrl', 'imageUrl', 'image_url', 'productImage', 'product_image', 'product_img'];
    for (const prop of commonImageProps) {
        if (item[prop] && typeof item[prop] === 'string') {
            return item[prop];
        }
    }

    // Then scan all properties for values that look like image URLs
    for (const key of Object.keys(item)) {
        let value = item[key];

        // Skip if not a string
        if (typeof value !== 'string') {
            continue;
        }

        // Check if the string starts with http or https
        if (value.startsWith('http')) {
            // Check if it has an image extension
            const hasImageExtension = imageExtensions.some(ext =>
                value.toLowerCase().includes(ext)
            );

            // Check if it has an image host domain
            const hasImageHost = imageHosts.some(host =>
                value.toLowerCase().includes(host)
            );

            // Check if it has image-related URL patterns
            const hasImagePattern = imageUrlPatterns.some(pattern =>
                value.toLowerCase().includes(pattern)
            );

            if (value.includes("drive") || value.includes("google.com")) {
                // Encode url to base64
                const base64Url = btoa(encodeURIComponent(value));
                value = `http://cache-1.hunchads.com/cache/${get('user').teamId}?encoding=base64&url=${base64Url}`;
            }

            // If any condition is true, it's likely an image URL
            if (hasImageExtension || hasImageHost || hasImagePattern) {
                return value;
            }
        }
    }

    // No image URL found
    return null;
}
